/**
 * Closure reasons specifically for FISA penalty notice journey
 * These reasons are tailored for users closing their account with penalties
 */
export const fisaPenaltyClosureReasons = [
    { value: 'unhappy_with_interest_rates', label: "I'm unhappy with the interest rates" },
    { value: 'unhappy_with_service', label: "I'm unhappy with the service or product features" },
    { value: 'prefer_app_management', label: 'I would prefer to manage my account via an app' },
    { value: 'need_money_other_purpose', label: 'I need the money for another purpose' },
    { value: 'funds_not_ready', label: 'My funds are not yet ready to be used to fund the account' },
    { value: 'no_longer_eligible', label: "I'm no longer eligible (eg not a UK resident)" },
    { value: 'other', label: 'Other' }
];
